export default "__VITE_ASSET__ac17f8e8__"